import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';

import { init } from 'echarts';
import Empty from '@/component/empty';
import { isEmpty } from 'lodash';
import Color from '@/tool/color';
import moIndex from '../../store';
import moWelfare from '../store';

interface IProps {}
interface IState {}
let echartdom: any = null;

const WelfareBudget = (props: IProps, state: IState) => {
  const { PerCapitaWelfareDate } = moWelfare;
  const { isMock } = moIndex;
  const topRef = useRef<any>(null);
  const render = () => {
    if (echartdom) echartdom.dispose();
    echartdom = init(topRef.current);
    const option = {
      legend: {
        data: [],
      },
      grid: {
        left: '3%',
        right: '3%',
        bottom: 10,
        top: 10,
        containLabel: true,
      },
      yAxis: [
        {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: Color.blackColor(0.1),
              width: 1,
              type: 'dashed',
            },
          },
          splitNumber: 4,
          axisLine: {
            show: true,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisLabel: {
            show: true,
            color: Color.blackColor(0.5),
            fontFamily: 'Roboto',
            fontSize: 12,
          },
        },
      ],
      xAxis: [
        {
          type: 'category',
          axisLine: {
            show: true,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: Color.blackColor(0.85),
            fontFamily: 'Roboto',
            fontSize: 12,
          },
          data: ['25分位', '50分位', '75分位'],
        },
      ],
      series: [
        {
          name: '人均福利预算',
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            fontFamily: 'Roboto',
            fontSize: 12,
            formatter: (parmes: any) => {
              return `${Number(Math.round(parmes.data)).toLocaleString()}`;
            },
          },
          emphasis: {
            focus: 'self',
            blurScope: 'coordinateSystem',
          },
          color: Color.primary,
          lineStyle: {
            color: Color.primary,
            width: 2,
          },
          itemStyle: {
            borderRadius: [2, 2, 0, 0],
          },
          barWidth: 16,
          data: PerCapitaWelfareDate,
        },
      ],
    };
    echartdom.setOption(option);
  };

  useEffect(() => {
    if (
      PerCapitaWelfareDate[0] ||
      PerCapitaWelfareDate[1] ||
      PerCapitaWelfareDate[2]
    ) {
      render();
    }
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  }, [PerCapitaWelfareDate]);

  return (
    <section className="welfare-budget">
      {(PerCapitaWelfareDate[0] ||
      PerCapitaWelfareDate[1] ||
      PerCapitaWelfareDate[2]) ? (
          <section
            ref={topRef}
            className="budget-svg"
            style={{
              backgroundImage: isMock ?
                'url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)' :
                '',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
            }}/>
        ) : (
          <Empty margin="20px 0 0" />
        )}
    </section>
  );
};

export default observer(WelfareBudget);
